import axios from "axios";
import { apiWrapWithErrorWithData, headersProvider } from "../apiHelpers";
import constants from "../constants";

export const sendGridData = async () => {
  return axios.get(`${constants.apiHost}/sendgrid/stats`, {
    headers: {
      ...headersProvider(),
    },
  });
};

export const getComplianceStatus = async ({ filters, page, pageSize }) => {
  const obligationApi = `https://obmasterapi.truecounsel.in`;
  return axios
    .post(
      `${obligationApi}/getcomplaincestatus`,
      { filters, page, pageSize },
      {
        headers: headersProvider(),
      },
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error getting bu list", error.message);
      throw error;
    });
};
const recoveryApi = "https://recmasterapi.truecounsel.in";
export const getRecoveryDashboardTable = (data) => {
  return axios.post(`${recoveryApi}/dashboard/table-data`, data, {
    headers: headersProvider(),
  });
};

export const getDashboardData = (data) =>
  axios.post(`${recoveryApi}/dashboard/initial-data`, data, {
    headers: headersProvider(),
  });

export const getVPSData = () => {
  // Get today's date
  const today = new Date();
  const todayISO = today.toISOString(); // Format as ISO string

  // Get yesterday's date
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1); // Subtract 1 day
  const yesterdayISO = yesterday.toISOString(); // Format as ISO string

  const url = `https://developers.hostinger.com/api/vps/v1/virtual-machines/427807/metrics?date_from=${encodeURIComponent(
    yesterdayISO,
  )}&date_to=${encodeURIComponent(todayISO)}`;
  return axios.get(url, {
    headers: {
      Accept: "application/json",
      Authorization: constants.hostingerApiKey,
    },
  });
};
